
import { Component, Prop, Provide } from "vue-property-decorator";
import Vue from "vue";
import SearchBox, {
  SearchBoxState
} from "@/components/ElementPropertiesPanel/SearchBox.vue";
import { configStore, globalStore } from "@/store/store-accessor";
import { filterControls, flattenAndCount } from "@/lib/controls/search";
import { ChangeControlValueMeta, ControlsTreeContext } from "@/types/controls";
import lodash from "lodash";
import { addMetadataToSettingPropertyChangeBasingOnControlValueChangeMetadata } from "@/lib/controls/utils";
import {
  getGlobalSettingsAccordionState,
  setGlobalSettingsAccordionState
} from "@/lib/panels/accordions";
import ControlsTree from "@/components/Reusable/ControlsTree/ControlsTree.vue";
import Icon from "@/components/UI/Icon.vue";
import SearchBoxEmptyState from "@/components/ElementPropertiesPanel/SearchBoxEmptyState.vue";

@Component({
  components: { ControlsTree, SearchBox, Icon, SearchBoxEmptyState }
})
export default class GlobalSettingsPanelControlsViewMode extends Vue {
  @Prop({ default: false })
  isLoading!: boolean;

  searchBoxState: SearchBoxState = {
    modifiedOnly: false,
    query: ""
  };

  updateSearchBoxState(newSearchBoxState: SearchBoxState) {
    this.searchBoxState = newSearchBoxState;
  }

  clearQuery() {
    this.updateSearchBoxState({
      modifiedOnly: false,
      query: ""
    });
  }
  get controls() {
    return configStore.globalSettingsControlsAndTemplate.controls;
  }

  get controlsFilteredBySearchParams() {
    return filterControls(
      this.controls,
      this.searchBoxState.modifiedOnly,
      this.searchBoxState.query,
      this.editingGlobalSettingsControlsTreeContext,
      "settings"
    );
  }

  get noSearchResults() {
    return flattenAndCount(this.controlsFilteredBySearchParams, 0) === 0;
  }

  get hasSearchParameters() {
    return this.searchBoxState.modifiedOnly || this.searchBoxState.query;
  }

  @Provide("context")
  editingGlobalSettingsControlsTreeContext =
    editingGlobalSettingsControlsTreeContext;
}

const editingGlobalSettingsControlsTreeContext: ControlsTreeContext = {
  getControlValue: controlPath => {
    return lodash.get(globalStore.globalSettings, controlPath);
  },
  setControlValue(
    controlPathProbablyWithBreakpointIdAndHoverSuffix,
    newValue,
    control,
    meta?: ChangeControlValueMeta
  ) {
    globalStore.throttledGlobalSettingsPropertyChange(
      addMetadataToSettingPropertyChangeBasingOnControlValueChangeMetadata(
        {
          path: controlPathProbablyWithBreakpointIdAndHoverSuffix,
          value: newValue
        },
        {
          control,
          controlsTree:
            this.getControls(
              controlPathProbablyWithBreakpointIdAndHoverSuffix
            ) || []
        },
        meta
      )
    );
  },
  getControls: () => configStore.globalSettingsControlsAndTemplate.controls,
  setAccordionState: (accordionPath: string, open: boolean) => {
    setGlobalSettingsAccordionState(accordionPath, open);
  },
  getAccordionState: (accordionPath: string) => {
    return getGlobalSettingsAccordionState(accordionPath);
  }
};
